import { LoginPage as LibraryLoginPage } from 'library';

import { oauth2Config } from '../config/auth';

const UNAUTHORIZED_REDIRECT = import.meta.env
  .VITE_UNAUTHORIZED_REDIRECT_PATH as string | undefined;

const LoginPage = () => {
  return (
    <LibraryLoginPage
      config={oauth2Config}
      unauthorizedRedirectUrl={UNAUTHORIZED_REDIRECT}
    />
  );
};

export default LoginPage;
